module.exports = __webpack_public_path__ + "media/images/chambres non-fumeurs-282f9a5c1782fa5d4a11ea22f7f8385a.svg";